import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider, createRouter } from '@tanstack/react-router';

import './App.css';

import { getWebInstrumentations, initializeFaro, } from '@grafana/faro-react';

// Import the generated route tree
import { FilterParam, SortParam, VisibilityParam } from './api/memberships';
import LoadingState from './components/LoadingState';
import { routeTree } from './routeTree.gen';

import { LicenseInfo } from '@mui/x-license';

// Create a new queryClient instance
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        }
    }
})

// Create a new router instance
const router = createRouter({
    routeTree,
    basepath: '/',
    defaultPendingComponent: () => {
        <LoadingState />
    },
    context: {
        queryClient
    },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0
})

initializeFaro({
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/89d259b439106a9fcf94f72ec959c027',
    app: {
        name: 'frontend',
        version: '0.25.0',
        environment: import.meta.env.VITE_ENVIRONMENT
    },

    instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations(),
    ],
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
    interface HistoryState {
        route: string,
        page: number,
        size: number,
        query?: string,
        queryDetail?: string,
        filter?: FilterParam[],
        sort?: SortParam[],
        additional?: VisibilityParam[],
        date?: Date,
    }
}


function App() {

    // console.log('App')
    LicenseInfo.setLicenseKey('9ce7a261e68ce315dcb42627dfcc4e33Tz0xMzEzNDMsRT0xODE2Mzg3MTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9c2luZ2xlLEtWPTI=')

    return <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} >

        </RouterProvider>
        {import.meta.env.VITE_DEBUG === 'true' &&
            <ReactQueryDevtools initialIsOpen={false} />
        }
    </QueryClientProvider>

}

export default App;